<template>
  <v-layout
    justify-center
    :pb-4="$vuetify.breakpoint.mdAndUp"
  >
    <v-flex
      xs10
      sm8
    >
      <slot name="actions" />
    </v-flex>
  </v-layout>
</template>

<script>
export default {
    name: 'AddFamilyTemplateActions',
    inject: ['$validator']
};
</script>

<style scoped></style>
